import { render, staticRenderFns } from "./InfoPago.vue?vue&type=template&id=e1a011f2&"
import script from "./InfoPago.vue?vue&type=script&lang=js&"
export * from "./InfoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports